import React from "react";
import PropTypes from "prop-types";

import css from "./index.module.scss";


const Backdrop = props => {
  const cssClass = props.visible ? "visible" : "hidden";
  const className = [css[cssClass], props.className].join(" ");

  if (props.onClick) {
    return (
      <div
        className={className}
        style={props.style}
        onClick={props.onClick}
        onKeyDown={event => (event.key === "Enter" || event.key === " ") && props.onClick(event)}
        role="button"
        tabIndex={0}
      >
        {props.children}
      </div>
    );
  }

  return (
    <div className={className} style={props.style}>
      {props.children}
    </div>
  );
};

Backdrop.defaultProps = {
  className: "",
  visible: false
};

Backdrop.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onClick: PropTypes.func,
  visible: PropTypes.bool,
  style: PropTypes.object
};

export default Backdrop;